import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
});

/*----------------------------------------
ラインアニメーション
------------------------------------------*/
const elements = document.querySelectorAll('.lineanime');
elements.forEach((target) => {
  ScrollTrigger.create({
    trigger: target,
    start: "top 90%",
    onEnter: () => target.classList.add('is-visible'), // その要素自身にクラスを付ける
  });
});

/*----------------------------------------
お問い合わせ アニメーション
------------------------------------------*/
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
function getHeaderHeight() {
  const header = document.querySelector('.nav');
  return header ? header.offsetHeight : 0;
}

document.addEventListener('tccf7:scrollTo', e => {
  gsap.to(window, {
    duration: 1,
    scrollTo: {
      y: "#" + e.detail.id,
      offsetY: getHeaderHeight()
    },
    ease: "power2.inOut"
  });
});

/*----------------------------------------
お問い合わせバリデーション
------------------------------------------*/
if(document.body.classList.contains("home")){
  topValidation('zip', 'address01', 'address02');
}

/*----------------------------------------
カレント（お問い合わせ以外）
------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  // #contact 以外のセクションを監視対象にする
  const sections = document.querySelectorAll('section[id]');
  const navLinks = document.querySelectorAll('.hd_nav_link');

  const options = {
    root: null,
    rootMargin: "-50% 0px", // 画面中央付近で切り替え
    threshold: 0
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 全てのリンクから一旦 is-active クラスを削除
        navLinks.forEach(link => link.classList.remove('is-active'));

        // 現在表示中のセクションIDに紐づくリンクにのみクラスを付与
        const id = entry.target.getAttribute('id');
        const activeLink = document.querySelector(`.hd_nav_link[href="#${id}"]`);

        if (activeLink) {
          activeLink.classList.add('is-active');
        }
      }
    });
  }, options);

  sections.forEach(section => observer.observe(section));

  // お問い合わせに入ったらカレント削除
  const contactSection = document.querySelector('#contact');
  if (contactSection) {
    const contactObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          navLinks.forEach(link => link.classList.remove('is-active'));
        }
      });
    }, { rootMargin: "-20% 0px" });
    contactObserver.observe(contactSection);
  }
});

/*----------------------------------------
smooth scroll page外リンク
------------------------------------------*/
window.addEventListener('load', () => {
  if (location.hash) {
    const header = document.querySelector('.nav');
    const headerHeight = header ? header.offsetHeight : 0;
    const urlHash = location.hash;

    setTimeout(() => {
      gsap.to(window, {
        duration: 0.5,
        scrollTo: {
          y: urlHash,
          offsetY: headerHeight
        }
      });
    }, 80);
  }
});

/*----------------------------------------
smooth scroll page内リンク
------------------------------------------*/
gsap.registerPlugin(ScrollToPlugin);

window.addEventListener("load", () => {
  const navLinks = document.querySelectorAll('a[href^="#"]');

  navLinks.forEach((navLink) => {
    navLink.addEventListener("click", (e) => {
      const id = navLink.getAttribute("href");
      const target = document.querySelector(id);
      if (!target || id === "#") return;

      e.preventDefault();

      const offsetValue = window.innerWidth >= 1024 ? 99 : 50;

      gsap.to(window, {
        duration: 0.5,
        ease: "power3.out",
        scrollTo: {
          y: target,
          offsetY: offsetValue,
          autoKill: false
        }
      });
    });
  });
});

/*----------------------------------------
メイン領域に入ったらヘッダーを表示
------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  const mainSection = document.querySelector('.main');

  if (!header || !mainSection) return;

  let scrollHandler = null;

  const handleScroll = () => {
    const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const viewportHeight = window.innerHeight;
    const threshold = viewportHeight - 250;

    if (scroll > threshold) {
      header.classList.add('is_fixed');
    } else {
      header.classList.remove('is_fixed');
    }
  };

  const updateScrollEvent = () => {
    const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const mainTop = mainSection.offsetTop;

    // 画面幅が1024以上かつ main の上端が画面の一番上に来たらスクロールイベントを有効化
    if (window.innerWidth >= 1024 && scroll >= mainTop) {
      if (!scrollHandler) {
        scrollHandler = handleScroll;
        window.addEventListener('scroll', scrollHandler);
        handleScroll(); // 初回判定
      }
    } else {
      // 画面幅が1024未満、または main の上端前 → イベント削除
      if (scrollHandler) {
        window.removeEventListener('scroll', scrollHandler);
        scrollHandler = null;
        header.classList.remove('is_fixed');
      }
    }
  };

  // 初回実行
  updateScrollEvent();

  // スクロール時に main 上端判定
  window.addEventListener('scroll', updateScrollEvent);

  // リサイズ時にも判定
  window.addEventListener('resize', updateScrollEvent);
});

/*------------------------------------------------
ハンバーガーメニュー
--------------------------------------------------*/
let button = document.querySelector('.hd_menu_btn');
let nav_box = document.querySelector('.hd_nav_box');

if (button && nav_box) {
  button.addEventListener('click', function() {

    if (nav_box.classList.contains('is_open')) {
      nav_box.classList.remove("is_open");
      button.classList.remove("is_close");
    } else {
      nav_box.classList.add("is_open");
      button.classList.add("is_close");
    }

  });
}

/*------------------------------------------------
ハンバーガーメニュー　リンク押したらメニュー閉じる
--------------------------------------------------*/
  let links = document.querySelectorAll('.hd_nav_link');
  links.forEach((link) => {
    link.addEventListener('click', function() {
      setTimeout(() => {
        nav_box.classList.remove("is_open");
        button.classList.remove("is_close");
      }, 100);
    });
  });

/*------------------------------------------------
spヘッダー動き
--------------------------------------------------*/
  window.addEventListener('scroll', () => {
    const header = document.querySelector('.header');
    const windowWidth = window.innerWidth;

    if (windowWidth >= 1024) {
      // 1024px以上: 常に表示
      header.classList.add('is-visible');
    } else {
      // スクロールで表示・非表示
      if (window.scrollY > 50) {
        header.classList.add('is-visible');
      } else {
        header.classList.remove('is-visible');
      }
    }
  });


/*------------------------------------------------
初回のみOPアニメーション表示
--------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  const loading = document.getElementById('svgLoading');
  const firstVisit = sessionStorage.getItem('firstVisit') !== 'done';

  if (firstVisit) {
    loading.classList.add('show'); //クラス追加

    setTimeout(() => {
      loading.style.opacity = '0';
      loading.style.transition = 'opacity 0.5s ease';

      setTimeout(() => {
        loading.remove();
      }, 1200);

    },1600);

    sessionStorage.setItem('firstVisit', 'done');
  } else {
    loading.remove();
  }
});

/*----------------------------------------
要素アニメーション
------------------------------------------*/
const item = document.querySelectorAll('.scrollAnim');
item.forEach((target) => {
  ScrollTrigger.create({
    trigger: target,
    start: "top 90%",
    onEnter: () => target.classList.add('active'), // その要素自身にクラスを付ける
  });
});